
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type {
    CollectionPlatformType,
    CollectionPlatformPayloadType,
} from "@/common/types/collection-platform";

export async function collectionPlatformList(
    collection_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `collection/${collection_id}/platform/list${queryString}`
    );
}

export async function collectionPlatformGet(
    item_id: string
) {
    return await clientAxios.get(
        `collection/platform/${item_id}/show`
    );
}

export async function collectionPlatformCreate(
    collection_id: string,
    payload: CollectionPlatformPayloadType
) {
    return await clientAxios.post(
        `collection/${collection_id}/platform/create`,
        payload
    );
}

export async function collectionPlatformPatch(
    item_id: string,
    payload: Partial<CollectionPlatformType>
) {
    return await clientAxios.patch(
        `collection/platform/${item_id}/patch`,
        { payload }
    );
}

export async function collectionPlatformDel(
    item_id: string,
) {
    return await clientAxios.del(
        `collection/platform/${item_id}/delete`,
    );
}
